import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { Msg } from '../model/user.model';
import { AuthService } from '../service/auth.service';

@Component({
    selector: 'app-forgot-username',
    templateUrl: './forgot-username.component.html',
    styleUrls: ['./forgot-username.component.scss']
})
export class ForgotUsernameComponent implements OnInit {
    form: UntypedFormGroup;
    isLoading: boolean = false;

    msg: Msg = new Msg();

    constructor(private fb: UntypedFormBuilder, private auth: AuthService, private router: Router, private store: Store<AppState>) {
        this.form = fb.group({
            email: ['', [Validators.email, Validators.required]],
            captcha: ['', []]
        });
    }

    ngOnInit(): void {}

    submit() {
        this.isLoading = true;
        const val = this.form.value;
        this.auth
            .forgotUsername(val.email)
            .pipe()
            .subscribe((res) => {
                this.isLoading = false;
                if (res['msg']) {
                    this.msg = res['msg'];
                }
            });
    }
}
